/**
 * "Recent searches" empty-state section for SearchCommand. Pure presentation.
 * Receives the cached items + handlers from the parent's `useRecentSearches`.
 */
import { Clock } from "lucide-react";

export default function SearchRecentSection({ recent, onReplay, onClear }) {
  if (!recent || recent.length === 0) return null;
  return (
    <div className="border-b border-rp-border" data-testid="search-recent-section">
      <div className="flex items-center justify-between px-4 py-2 text-[10px] font-mono uppercase tracking-[0.18em] text-rp-textFaint bg-rp-surface/50">
        <span className="inline-flex items-center gap-1">
          <Clock className="h-3 w-3" /> Recent
        </span>
        <button
          type="button"
          onClick={onClear}
          className="text-rp-textFaint hover:text-rp-text normal-case tracking-normal"
          data-testid="search-recent-clear"
        >
          clear
        </button>
      </div>
      <ul>
        {recent.map((r, i) => (
          <li key={`${r.q}-${i}`}>
            <button
              type="button"
              onClick={() => onReplay(r)}
              className="w-full text-left px-4 py-2.5 flex items-center gap-3 hover:bg-rp-surface/60"
              data-testid={`search-recent-${i}`}
            >
              <Clock className="h-3.5 w-3.5 text-rp-textFaint shrink-0" />
              <span className="flex-1 min-w-0">
                <span className="block text-sm text-rp-text truncate">{r.title || r.q}</span>
                {r.path && (
                  <span className="block text-[10px] text-rp-textFaint font-mono mt-0.5">{r.path}</span>
                )}
              </span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
